import React from 'react';
import {
  // BrowserRouter as Router,
  // Switch,
  // Route,
  RouterProvider,
} from 'react-router-dom';

import Home from './pages/Home';
import Permit from './pages/Permit';
import AppendixA from './pages/appendix/A';
import AppendixB from './pages/appendix/B';
import AppendixC from './pages/appendix/C';
import AppendixD from './pages/appendix/D';
import AppendixE from './pages/appendix/E';
import AppendixF from './pages/appendix/F';
import AppendixG from './pages/appendix/G';
import AppendixH from './pages/appendix/H';
import AppendixI from './pages/appendix/I';
import AppendixJ from './pages/appendix/J';

// for testing
console.log('window:');
console.log(window);

const { basename } = window['config'];

const router = [
  {
    path: '/permit',
    element: <Permit />,
  },
  {
    path: '/:year-:month/only',
    element: <Home hideControls />,
  },
  {
    path: '/:year-:month',
    element: <Home />,
  },
  {
    path: '/appendix/a',
    element: <AppendixA />,
  },
  {
    path: '/appendix/b',
    element: <AppendixB />,
  },
  {
    path: '/appendix/c/:year-:month',
    element: <AppendixC />,
  },
  {
    path: '/appendix/d/:year-:month',
    element: <AppendixD />,
  },
  {
    path: '/appendix/e/:year-:month',
    element: <AppendixE />,
  },
  {
    path: '/appendix/f/:year-:month',
    element: <AppendixF />,
  },
  {
    path: '/appendix/g/:year-:month',
    element: <AppendixG />,
  },
  {
    path: '/appendix/h/:year-:month',
    element: <AppendixH />,
  },
  {
    path: '/appendix/i/:year-:month',
    element: <AppendixI />,
  },
  {
    path: '/appendix/j/:year-:month',
    element: <AppendixJ />,
  },
  {
    path: '/',
    element: <Home />,
  },
];

class App extends React.Component {
  render() {
    return <RouterProvider router={router} />;
    // return (
    //   <Router basename={basename}>
    //     <Switch>
    //       <Route path='/permit'>
    //         <Permit />
    //       </Route>
    //       <Route path='/:year-:month/only'>
    //         <Home hideControls />
    //       </Route>
    //       <Route path='/:year-:month'>
    //         <Home />
    //       </Route>
    //       <Route path='/appendix/a'>
    //         <AppendixA />
    //       </Route>
    //       <Route path='/appendix/b'>
    //         <AppendixB />
    //       </Route>
    //       <Route path='/appendix/c/:year-:month'>
    //         <AppendixC />
    //       </Route>
    //       <Route path='/appendix/d/:year-:month'>
    //         <AppendixD />
    //       </Route>
    //       <Route path='/appendix/e/:year-:month'>
    //         <AppendixE />
    //       </Route>
    //       <Route path='/appendix/f/:year-:month'>
    //         <AppendixF />
    //       </Route>
    //       <Route path='/appendix/g/:year-:month'>
    //         <AppendixG />
    //       </Route>
    //       <Route path='/appendix/h/:year-:month'>
    //         <AppendixH />
    //       </Route>
    //       <Route path='/appendix/i/:year-:month'>
    //         <AppendixI />
    //       </Route>
    //       <Route path='/appendix/j/:year-:month'>
    //         <AppendixJ />
    //       </Route>
    //       <Route path='/'>
    //         <Home />
    //       </Route>
    //     </Switch>
    //   </Router>
    // );
  }
}

export default App;
